import { render, staticRenderFns } from "./calculadora.vue?vue&type=template&id=0988d6a3"
import script from "./calculadora.vue?vue&type=script&lang=js"
export * from "./calculadora.vue?vue&type=script&lang=js"
import style0 from "./calculadora.vue?vue&type=style&index=0&id=0988d6a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports